module.exports = __webpack_public_path__ + "img/climate_actions_solar_energy.f49ac1c.webp";